/* Así funciona · Base con Ruedas para Lavadora y Nevera (2110176)
   1) Las barras (galeria_1, foto REAL con los dos estados: la barra de atrás RECOGIDA y la de adelante ESTIRADA con el
      tubo interior y su ranura a la vista). La clienta jala el taco negro de la barra de adelante (o usa el deslizador):
      el extremo real (taco + soporte con ruedas + tubo interior con ranura) corre por el eje real de la barra, con la
      escala de la perspectiva (punto de fuga medido con los bordes de la barra), y sale del tubo exterior real, que lo
      tapa (capa encima). Recogida = el taco pegado a la boca del tubo, igual que la barra de atrás de la misma foto;
      estirada = la foto tal cual.
   2) Con la lavadora (originales/f_1221129d13: foto REAL de la lavadora sobre la base, sin sus flechas): la clienta la
      empuja y la jala; rueda sobre las barras en el sentido de las barras (adelante/atrás, como muestran las flechas de
      esa foto), con la perspectiva de la foto (escala hacia el punto de fuga de las barras de los lados) y su sombra de
      contacto acompañándola.
   Ficha: barras extensibles, ruedas para moverla fácil, para lavadora, nevera y muebles (sin medidas: no se dicen).
   Piezas: tiendas/nayhogar/funciona/base-con-ruedas-para-lavadora-y-nevera/hacer.py */
NHF.escena('base-con-ruedas-para-lavadora-y-nevera', function (E) {
  const D = /*DATOS*/{"VB":[3767.3,-285.5],"ref":[620,1000],"D":212.0,"extremo":{"caja":[168,859,570,336],"src":"fn-base-con-ruedas-para-lavadora-y-nevera-extremo.webp"},"funda":{"caja":[648,723,366,282],"src":"fn-base-con-ruedas-para-lavadora-y-nevera-funda.webp"},"agarre":[170,850,670,340],"base":"fn-base-con-ruedas-para-lavadora-y-nevera-base.webp","lavadora":{"caja":[357,390,906,760],"fuga":[1836.1,555.7],"sombra_caja":[642,1003,640,172],"ancla":[896.7,1109.6],"agarre":[417,430,786,700],"src":"fn-base-con-ruedas-para-lavadora-y-nevera-lavadora.webp","sombra":"fn-base-con-ruedas-para-lavadora-y-nevera-lavadora-sombra.webp"},"fondo":"fn-base-con-ruedas-para-lavadora-y-nevera-fondo.webp"}/*FIN*/;
  const S = E.lienzo({ w: 1600, h: 1600, vista: [140, 330, 1340, 960], vistaMovil: [140, 290, 1320, 1000] });
  E.titulo('Estírala y [muévela].', 'Jala el taco negro de la barra: el tubo sale de su funda. Después súbele la lavadora y empújala.');
  E.conSonido();
  S.cargando(true);

  /* ---------- vista 1: las barras ---------- */
  const gB = S.grupo([0, 0, 1600, 1600], { z: 1 });
  gB.style.transition = 'opacity .7s ease';
  S.img(D.base, null, { en: gB, z: 1, alt: 'Dos barras de la base con ruedas: una recogida y otra estirada' });
  const ext = S.img(D.extremo.src, D.extremo.caja, { en: gB, z: 2 });
  S.img(D.funda.src, D.funda.caja, { en: gB, z: 3 });
  const EC = D.extremo.caja, VB = D.VB, DMAX = D.D;
  const LB = Math.hypot(VB[0] - D.ref[0], VB[1] - D.ref[1]);
  const DIRB = [(VB[0] - D.ref[0]) / LB, (VB[1] - D.ref[1]) / LB];
  ext.style.transformOrigin = (VB[0] - EC[0]) + 'px ' + (VB[1] - EC[1]) + 'px';

  /* ---------- vista 2: la lavadora sobre la base ---------- */
  const L = D.lavadora;
  const gL = S.grupo([0, 0, 1600, 1600], { z: 2, opacidad: 0 });
  gL.style.transition = 'opacity .7s ease'; gL.style.visibility = 'hidden';
  S.img(D.fondo, [0, 0, 1600, 1600], { en: gL, z: 1 });
  const gRueda = S.grupo([0, 0, 1600, 1600], { en: gL, z: 2 });
  gRueda.style.transformOrigin = L.fuga[0] + 'px ' + L.fuga[1] + 'px';
  S.img(L.sombra, L.sombra_caja, { en: gRueda, z: 1 });
  S.img(L.src, L.caja, { en: gRueda, z: 2, alt: 'Lavadora sobre la base con ruedas' });
  const LA = Math.hypot(L.fuga[0] - L.ancla[0], L.fuga[1] - L.ancla[1]);
  const DIRL = [(L.fuga[0] - L.ancla[0]) / LA, (L.fuga[1] - L.ancla[1]) / LA];
  const UMIN = -70, UMAX = 170;

  E.cargar([D.base, D.extremo.src, D.funda.src]).then(() => { S.cargando(false); E.cargar([D.fondo, L.sombra, L.src]); });

  /* ---------- estado ---------- */
  let k = 0, metaK = 0;   // barra: 0 = recogida (taco en la boca del tubo) · 1 = estirada (la foto)
  let u = 0, metaU = 0;   // lavadora: px recorridos sobre las barras (+ hacia atrás)
  let vista = 'barras', vioEstirada = false, recorrido = 0, toco = false, terminado = false;

  /* ---------- panel ---------- */
  const seg = E.seg([{ id: 'barras', texto: 'Las barras' }, { id: 'lavadora', texto: 'Con la lavadora' }], v => verVista(v), { etiqueta: 'Qué ver' });
  E.pasos(['Jala el taco negro: la barra se estira', 'Súbele la lavadora', 'Empújala: rueda sobre la base']);
  E.paso(0);
  const rango = E.deslizador({ etiqueta: 'Barra de adelante', min: 0, max: 100, valor: 0, formato: v => v < 3 ? 'Recogida' : v > 97 ? 'Estirada' : 'A tu medida' }, v => { tocado(); metaK = v / 100; arrancar(); });
  const bLav = E.boton('Ponle la lavadora', () => { seg.elegir('lavadora'); verVista('lavadora'); }, { icono: 'toca', primario: true });
  bLav.hidden = true;
  E.nota('Para lavadora, nevera y muebles: las barras se ajustan al tamaño del electrodoméstico.');

  function pintarBarra() {
    const d = DMAX * (1 - k);
    ext.style.transform = 'scale(' + (1 - d / LB).toFixed(5) + ')';
    rango.poner(Math.round(k * 100));
  }
  function pintarLav() { gRueda.style.transform = 'scale(' + (1 - u / LA).toFixed(5) + ')'; }

  /* ---------- un solo bucle de movimiento con inercia ---------- */
  let corriendo = false, ultTope = 0, ruido = null;
  function arrancar() {
    if (corriendo) return; corriendo = true;
    let ult = performance.now();
    const paso = t => {
      const dt = Math.min(0.05, (t - ult) / 1000); ult = t;
      const f = Math.min(1, dt * (E.reduce ? 60 : 9));
      const dk = metaK - k, du = metaU - u;
      k += dk * f; if (Math.abs(metaK - k) < 0.002) k = metaK;
      const u0 = u; u += du * Math.min(1, dt * (E.reduce ? 60 : 5)); if (Math.abs(metaU - u) < 0.3) u = metaU;
      recorrido += Math.abs(u - u0);
      pintarBarra(); pintarLav();
      const tope = k >= 0.999 ? 1 : k <= 0.001 ? 0 : -1;
      if (vista === 'barras' && tope >= 0 && tope !== ultTope) { E.sonido.clic(); E.vibrar(8); }
      ultTope = tope;
      if (ruido) ruido.volumen(Math.min(0.03, Math.abs(u - u0) * 0.004));
      if (k !== metaK || u !== metaU) requestAnimationFrame(paso);
      else { corriendo = false; if (ruido) { ruido.parar(); ruido = null; } guia(); }
    };
    requestAnimationFrame(paso);
  }

  /* ---------- arrastrar el taco (barra) ---------- */
  const zB = S.toque(D.agarre, { en: gB, etiqueta: 'Taco de la barra: jálalo para estirarla o empújalo para recogerla' });
  zB.style.touchAction = 'pan-y'; zB.style.cursor = 'ew-resize';
  let aB = null;
  zB.addEventListener('pointerdown', e => { tocado(); aB = { p: S.punto(e), k0: k }; try { zB.setPointerCapture(e.pointerId); } catch (x) {} E.sonido.tono(600, .03, .02); });
  zB.addEventListener('pointermove', e => {
    if (!aB) return;
    const p = S.punto(e), s = (p.x - aB.p.x) * DIRB[0] + (p.y - aB.p.y) * DIRB[1]; // + hacia la boca = recoger
    metaK = E.clamp(aB.k0 - s / DMAX, 0, 1); arrancar();
  });
  const sB = () => { aB = null; };
  zB.addEventListener('pointerup', sB); zB.addEventListener('pointercancel', sB);
  zB.addEventListener('keydown', e => { // teclado: flecha izquierda estira, derecha recoge
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); tocado(); metaK = E.clamp(metaK + (e.key === 'ArrowLeft' ? 0.25 : -0.25), 0, 1); arrancar(); }
  });

  /* ---------- empujar / jalar la lavadora ---------- */
  const ag = L.agarre;
  const zL = S.toque(ag, { en: gRueda, etiqueta: 'Lavadora: empújala o jálala, rueda sobre la base' });
  zL.style.touchAction = 'pan-y'; zL.style.cursor = 'grab';
  let aL = null;
  zL.addEventListener('pointerdown', e => {
    tocado(); aL = { p: S.punto(e), u0: u, t: performance.now(), v: 0, ult: S.punto(e) };
    try { zL.setPointerCapture(e.pointerId); } catch (x) {}
    if (!ruido) ruido = E.sonido.ruido(0, 0, 380);
  });
  zL.addEventListener('pointermove', e => {
    if (!aL) return;
    const p = S.punto(e), s = (p.x - aL.p.x) * DIRL[0] + (p.y - aL.p.y) * DIRL[1];
    const now = performance.now(), ds = (p.x - aL.ult.x) * DIRL[0] + (p.y - aL.ult.y) * DIRL[1];
    aL.v = ds / Math.max(8, now - aL.t) * 1000; aL.t = now; aL.ult = p;
    metaU = E.clamp(aL.u0 + s, UMIN, UMAX); arrancar();
  });
  const sL = () => { if (!aL) return; metaU = E.clamp(metaU + aL.v * 0.12, UMIN, UMAX); aL = null; arrancar(); }; // sigue rodando un poco
  zL.addEventListener('pointerup', sL); zL.addEventListener('pointercancel', sL);
  zL.addEventListener('keydown', e => { // teclado: flecha derecha la empuja hacia atrás, izquierda la trae
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); tocado(); metaU = E.clamp(metaU + (e.key === 'ArrowRight' ? 60 : -60), UMIN, UMAX); arrancar(); }
  });

  /* ---------- vistas ---------- */
  function verVista(v) {
    vista = v;
    const lav = v === 'lavadora';
    if (lav) gL.style.visibility = 'visible';
    gL.style.opacity = lav ? 1 : 0; gB.style.opacity = lav ? 0 : 1;
    gB.style.pointerEvents = lav ? 'none' : ''; gL.style.pointerEvents = lav ? '' : 'none';
    zB.style.display = lav ? 'none' : ''; zL.style.display = lav ? '' : 'none';
    setTimeout(() => { if (vista === 'barras') gL.style.visibility = 'hidden'; }, 750);
    rango.hidden = lav; bLav.hidden = lav || !vioEstirada;
    guia();
  }

  /* ---------- guía ---------- */
  function tocado() { toco = true; S.el.classList.add('is-tocado'); }
  function guia() {
    if (k > 0.97) vioEstirada = true;
    if (vista === 'barras') {
      bLav.hidden = !vioEstirada;
      if (!vioEstirada) { E.paso(0); S.pista(k > 0.2 ? 'Sigue jalando: hasta que se vea la ranura' : 'Jala el taco negro hacia la izquierda', 'flechas'); }
      else { E.paso(1); S.pista('Así se estira. Ahora ponle la lavadora', 'toca'); }
      return;
    }
    if (recorrido < 230) { E.paso(vioEstirada ? 2 : 1); S.pista('Empuja la lavadora hacia atrás o jálala', 'mano'); return; }
    E.paso(3); S.pista(null);
    if (!terminado) { terminado = true; E.listo('Las barras se ajustan a tu lavadora o nevera, y con las ruedas la mueves sola para limpiar debajo y detrás.', reiniciar); }
  }
  function reiniciar() {
    E.noListo(); terminado = false; vioEstirada = false; recorrido = 0; metaK = 0; metaU = 0;
    seg.elegir('barras'); verVista('barras'); arrancar(); E.paso(0);
  }

  zL.style.display = 'none';
  pintarBarra(); pintarLav();
  S.pista('Jala el taco negro hacia la izquierda', 'flechas');
  // insinuación suave al aparecer: el taco sale un poco y vuelve (si la clienta aún no tocó nada)
  E.alVer(() => {
    if (E.reduce) return;
    setTimeout(() => {
      if (toco) return;
      E.animarP(650, x => { if (!toco) { k = 0.22 * x; pintarBarra(); } })
        .then(() => E.esperar(250))
        .then(() => E.animarP(550, x => { if (!toco) { k = 0.22 * (1 - x); pintarBarra(); } }));
    }, 900);
  }, 0.5);
});
